import type { StorefrontNetworkAndPvRecCategory } from '@api/storefrontsNetworkPvRec';
import { atom } from 'jotai';
import type { createStore } from 'jotai/vanilla';

type StorefrontsNetworkState = {
	network: StorefrontNetworkAndPvRecCategory[];
};

const initialState: StorefrontsNetworkState = {
	network: [],
};

export const networkAtom = atom(initialState.network);

export const vendorNetworkCountAtom = atom((get) => {
	const network = get(networkAtom);
	return network.reduce(
		(total, category) => total + (category.storefrontNetwork?.length || 0),
		0,
	);
});

export const vendorNetworkPvRecCountAtom = atom((get) => {
	const network = get(networkAtom);
	return network.reduce(
		(total, category) => total + (category.pvRec?.length || 0),
		0,
	);
});

export const storefrontsNetworkDataAtom = atom((get) => ({
	network: get(networkAtom),
}));

export const getStorefrontsNetworkDataToHydrate = (
	store: ReturnType<typeof createStore>,
) => {
	const network = store.get(networkAtom);
	return {
		network,
	};
};

export const setStorefrontsNetworkData = (
	store: ReturnType<typeof createStore>,
	data: StorefrontNetworkAndPvRecCategory[],
) => {
	const network = data;

	store.set(networkAtom, network);
};

export const getStorefrontsNetworkInitialValues = (
	values: ReturnType<typeof getStorefrontsNetworkDataToHydrate>,
): Array<[typeof networkAtom, StorefrontNetworkAndPvRecCategory[]]> => {
	const { network } = values || {};
	return [[networkAtom, network ?? initialState.network]];
};
